export function brokerJobsQueryKey(nxObjectUuid: string) {
	return ['broker-jobs', nxObjectUuid];
}
